// Writes the per-language names of custom ingredients into the ingredient rows, which already
// hold the name as a per-language map. Rows are matched on the trimmed default-language name, and
// the stored name itself is not rewritten. Identical names on several rows all get the translation.

// True when the row's name is a per-language map, so dropdown ingredients (a plain key string)
// and arrays are skipped.
function hasTranslatableName (row) {
  return !!row && !!row.description && typeof row.description === 'object' && !Array.isArray(row.description)
}

// Returns how many rows got translations. A missing list, or a removal flag in place of one, is skipped.
function applyIngredientNameTranslations ({ lists, translationsByName, defaultLanguage }) {
  let updatedRows = 0

  lists.forEach((list) => {
    if (!Array.isArray(list)) return
    list.forEach((row) => {
      if (!hasTranslatableName(row)) return
      const name = String(row.description[defaultLanguage] ?? '').trim()
      if (!Object.prototype.hasOwnProperty.call(translationsByName, name)) return

      const translations = translationsByName[name]
      Object.keys(translations).forEach((languageKey) => {
        // Skip the default language, because rewriting the text the row was found by would rename the ingredient.
        if (languageKey === defaultLanguage) return
        row.description[languageKey] = translations[languageKey]
      })
      updatedRows++
    })
  })

  return updatedRows
}

module.exports = {
  applyIngredientNameTranslations
}
